<template>
  <v-layout column>
    <v-flex>
      <sub-header :subHeaderConfig="subHeaderConfig" />
    </v-flex>
    <v-flex>
      <v-container fluid class="main-content-ctr">
        <v-layout align-start justify-start row>
          <v-flex lg3 shrink class="aside-stepper">
            <stepper-comp :stepperConfig="stepperConfig" />
          </v-flex>
          <v-flex lg8>
            <config-form />
          </v-flex>
          <v-flex lg1>
            <v-spacer></v-spacer>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
import _ from 'underscore'
import SubHeader from '../../components/subheader.vue'
import Stepper from '../../components/stepper.vue'
import ConfigForm from './subbrandConfigForm.vue'

export default {
  components: {
    'sub-header': SubHeader,
    'stepper-comp': Stepper,
    'config-form': ConfigForm
  },
  props: {},
  data() {
    return {}
  },
  created() {
    this.$store.state.appStore.editFlow = true
    let stepperId = this.$route.params.stepperId
    if (stepperId) {
      this.$store.state.createSubbrandStore.currentStep = stepperId
    } else {
      this.$store.state.createSubbrandStore.currentStep = 0
    }
    this.$nextTick(function () {
      document.getElementById('back-to-sub-brand-list-btn').focus();
    })
  },
  computed: {
    subHeaderConfig() {
      let publishedStatus = this.subbrandInfo.status
      let config = {
        headerText:
          publishedStatus === 7
            ? this.$lang.messages.create_sub_brand
            : this.$lang.messages.edit_sub_brand,
        headerSubText:
          publishedStatus != 7
            ? this.subbrandInfo.name 
            : '',
        backLink: {
          text: this.$route.params.backText,
          link: this.$route.params.backLink
        }
      }
      return config
    },
    stepperConfig() {
      let publishedStatus = this.subbrandInfo.status
      let config = {
        editFlow: publishedStatus != 7
      }
      return config
    },
    subbrandInfo() {
      return this.$store.state.appStore.selectedSubbrandInfo
    }
  }
}
</script>

<style>
  .aside-stepper {
    flex-basis: auto !important;
  }
</style>
